(() => {
  if (!window.DST_CATALOG_MODE) return;
  const purchasePath = /\/(?:cart(?:\/add|\/change|\/update)?|checkout)(?:\.js|\.json)?(?:\/|$)/i;
  function isPurchaseUrl(value) {
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin && purchasePath.test(url.pathname);
    } catch (_) { return false; }
  }
  document.addEventListener('submit', event => {
    if (isPurchaseUrl(event.target.action)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && isPurchaseUrl(link.href)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const notice = document.querySelector('.dst-catalog-banner');
      if (notice) notice.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, true);
  if (window.fetch) {
    const storefrontFetch = window.fetch.bind(window);
    window.fetch = (input, init) => {
      const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
      const method = ((init && init.method) || (typeof input === 'object' && input.method) || 'GET').toUpperCase();
      if (method !== 'GET' && method !== 'HEAD' && isPurchaseUrl(url)) {
        return Promise.resolve(new Response(JSON.stringify({ status: 422, message: 'Ordering is temporarily paused for website maintenance.' }), {
          status: 422,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      return storefrontFetch(input, init);
    };
  }
  const selectInitialVariant = () => {
    const chips = Array.from(document.querySelectorAll('.dst-variant-btn:not([disabled])'));
    if (!chips.length || typeof window.pdpSelectVariant !== 'function') return;
    const variant = new URLSearchParams(location.search).get('variant');
    const chip = chips.find(item => item.dataset.variantId === variant) || chips[0];
    window.pdpSelectVariant(chip);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectInitialVariant, { once: true });
  else selectInitialVariant();
})();

